import React from "react";
import { useTranslation } from "react-i18next";

function ForgotPasswordPage() {

    var { t } = useTranslation();

    return (
        <div className="uk-container uk-margin-large-top">
            <div className="uk-card uk-card-default uk-card-body uk-width-1-2@m uk-align-center uk-box-shadow-large">
                <h2 className="uk-card-title uk-text-center">Password Reset</h2>
                <p className="uk-text-center">
                    Our platform does not yet support automated password resets.
                </p>
                <p className="uk-text-center">
                    For assistance with resetting your password, please contact our CTO, Alan, directly via WhatsApp.
                </p>
                <div className="uk-text-center uk-margin-top">
                    <a 
                        href="https://wa.me/77471544504" 
                        className="uk-button uk-button-primary uk-button-jai"
                        target="_blank" 
                        rel="noopener noreferrer"
                    >
                        Contact Alan on WhatsApp
                    </a>
                </div>
            </div>
        </div>
    );
}

export default ForgotPasswordPage;